import React, { useEffect, useState } from "react";
import "./contenido.css";
import iconoCompartir from "../../../assets/imgs/detalle_blog/share-white.svg";
import iconoX from "../../../assets/imgs/detalle_blog/logo-x.svg";
import iconoFacebook from "../../../assets/imgs/detalle_blog/Asset_Facebook-normal.svg";
import iconoLinkedIn from "../../../assets/imgs/detalle_blog/LinkedIn.svg";
import iconoMail from "../../../assets/imgs/detalle_blog/Asset_Mail-Normalblanco.svg";
import iconoCopiar from "../../../assets/imgs/detalle_blog/Link.svg";
import { useLocation } from "react-router-dom";

const Contenido = ({ contenidoHtml, titulo }) => {
  const location = useLocation();
  const url = `https://ricardosalinas.com${location.pathname}`;
  const shareText = `Mira este post: ${url}`;
  const [fontSize, setFontSize] = useState(19); // Tamaño de fuente inicial

  // Función para aumentar el tamaño de la fuente
  const aumentarTamañoFuente = () => {
    if (fontSize < 28) {
      setFontSize((prevSize) => prevSize + 1); // Aumentar el tamaño en 1
    }
  };

  const disminuirTamañoFuente = () => {
    if (fontSize > 10) {
      setFontSize((prevSize) => prevSize - 1); // Disminuir el tamaño en 1
    }
  };

  const handleX = () => {
    window.open(
      `https://twitter.com/intent/tweet?url=${encodeURIComponent(
        url
      )}&text=${encodeURIComponent(titulo)}`,
      "_blank"
    );
  };

  const handleFacebook = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
      "_blank"
    );
  };

  const handleLinkedIn = (e) => {
    window.open(
      `https://www.linkedin.com/shareArticle?url=${encodeURIComponent(
        url
      )}&title=${encodeURIComponent(titulo)}`,
      "_blank"
    );
  };

  const handleMail = () => {
    window.location.href = `mailto:?subject=${encodeURIComponent(
      titulo
    )}&body=${encodeURIComponent(shareText)}`;
  };

  const handleCopiarURL = () => {
    navigator.clipboard.writeText(url).then(() => {
      alert('¡Enlace copiado al portapapeles!');
    }).catch((error) => {
      console.error('Error al copiar al portapapeles:', error);
    });
  };

  return (
    <div className="DB_contenido">

      <div className="contenido_html">
        <div className="barra_texto_Desk_div">
          <div className="barra_texto_Desk">
            <button>
              <div className="container-imagen">
                <img src={iconoCompartir} alt="icono compartir" />
              </div>
              <ul className="socials" onClick={(e) => e.stopPropagation()}>
                <li>
                  <img src={iconoX} alt="icono x" onClick={handleX} />
                </li>
                <li>
                  <img
                    src={iconoFacebook}
                    alt="icono facebook"
                    onClick={handleFacebook}
                  />
                </li>
                <li>
                  <img
                    src={iconoLinkedIn}
                    alt="icono linkedIn"
                    onClick={handleLinkedIn}
                  />
                </li>
                <li>
                  <img src={iconoMail} alt="icono mail" onClick={handleMail} />
                </li>
                <li>
                  <img
                    src={iconoCopiar}
                    alt="icono copiar url"
                    onClick={handleCopiarURL}
                  />
                </li>
              </ul>
            </button>
          </div>
        </div>
        <div
          dangerouslySetInnerHTML={{
            __html: contenidoHtml.replace(
              '<p style="text-align:right; margin-top:-10px;">Alfred Sauvy</p>',
              '<p style="text-align:right;margin-top:-10px;border-bottom: 1px solid black;">Alfred Sauvy</p>'
            ),
          }}
        />

        <style>
          {`@media only screen and (max-width: 700px) {
              #general p {
              font-size: ${fontSize}px !important;
              }

              #general .right-quote {
                font-size: ${fontSize + 2}px !important;
                }
              
              #general a {
                font-size: ${fontSize}px !important;
                }

              #general li {
                font-size: ${fontSize}px !important;
                }

              #entrada h2 {
                font-size: ${fontSize + 5}px !important;
              }

              #entrada blockquote {
                font-size: ${fontSize + 5}px !important;
              }
            }`}
        </style>

        <div className="barra_texto">
          <button onClick={disminuirTamañoFuente}>A -</button>
          <button onClick={aumentarTamañoFuente}>A +</button>
          <button>
            <div className="container-imagen">
              <img src={iconoCompartir} alt="icono compartir" />
            </div>
            <ul className="socials" onClick={(e) => e.stopPropagation()}>
              <li>
                <img src={iconoX} alt="icono x" onClick={handleX} />
              </li>
              <li>
                <img
                  src={iconoFacebook}
                  alt="icono facebook"
                  onClick={handleFacebook}
                />
              </li>
              <li>
                <img
                  src={iconoLinkedIn}
                  alt="icono linkedIn"
                  onClick={handleLinkedIn}
                />
              </li>
              <li>
                <img src={iconoMail} alt="icono mail" onClick={handleMail} />
              </li>
              <li>
                <img
                  src={iconoCopiar}
                  alt="icono copiar url"
                  onClick={handleCopiarURL}
                />
              </li>
            </ul>
          </button>
        </div>
      </div>
      <hr className="linea_baja"></hr>
    </div>
  );
};

export default Contenido;
